import { render, staticRenderFns } from "./ImportantDeadlines.vue?vue&type=template&id=3b65fd7e&"
import script from "./ImportantDeadlines.vue?vue&type=script&lang=js&"
export * from "./ImportantDeadlines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports